<template>
  <settings-page-card>
    <div class="flex items-center justify-between px-6">
      <h3 class="text-2xl font-semibold mb-0">
        Update User
      </h3>
    </div>

    <div class="flex flex-col mt-8 px-6">
      <b-form @submit.prevent="handleSubmit">
        <b-form-group label="Name">
          <b-input
            v-model="name"
            :disabled="loading"
            readonly
          />
        </b-form-group>

        <b-form-group label="Email">
          <b-input
            v-model="email"
            :disabled="loading"
            readonly
            type="email"
          />
        </b-form-group>

        <b-form-group
          label="Role Selection"
          class="mb-4"
        >
          <v-select
            v-model="role"
            :options="roles"
            :reduce="val => val.id"
            label="name"
            :disabled="loading"
            placeholder="Select Role"
            @blur="$v.role.$touch()"
            @input="$v.role.$touch()"
          >
            <template #no-options>
              No roles available
            </template>
          </v-select>
          <div
            v-if="$v.role.$error"
            class="text-sm text-red-600 mt-1"
          >
            {{ roleErrorMessage() }}
          </div>
        </b-form-group>

        <div class="flex items-center justify-end">
          <b-btn
            variant="primary"
            class="!bg-[#4F83E3] hover:!bg-[#3967d7]"
            type="submit"
            :disabled="isSubmitDisabled"
          >
            Update User
          </b-btn>
        </div>
      </b-form>
    </div>
  </settings-page-card>
</template>

<script>
import SettingsPageCard from '@/layouts/dashboard/SettingsPageCard.vue'
import {mapActions, mapState} from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ManageRoles',
  components: {SettingsPageCard},
  data () {
    return {
      name: '',
      email: '',
      role: null,
      roles: []
    }
  },
  computed: {
    ...mapState('roles', {
      loading: state => state.loading
    }),
    isSubmitDisabled () {
      return this.loading || this.$v.$invalid
    }
  },
  validations: {
    role: {
      required
    }
  },
  methods: {
    ...mapActions({
      getRoles: 'roles/getRoles',
      getMember: 'roles/getMember',
      updateMember: 'roles/updateMember'
    }),
    validationState (field) {
      const v = this.$v[field]
      if (!v) return null
      if (!v.$dirty) return null
      return !v.$invalid
    },
    roleErrorMessage () {
      if (!this.$v.role.$dirty) return ''
      return this.$v.role.required === false ? 'Please select a role.' : ''
    },
    async handleSubmit () {
      try {
        this.$v.$touch()

        if (this.$v.$invalid) {
          await this.$swal.fire({
            icon: 'warning',
            iconColor: '#4F83E3',
            title: 'Please select a role',
            showConfirmButton: false,
            timer: 1800
          })
          return
        }

        await this.updateMember({
          id: this.$route.params.member_id,
          body: {
            name: this.name,
            role_id: this.role
          }
        })

        await this.$swal.fire({
          icon: 'success',
          iconColor: '#4F83E3',
          title: 'User updated',
          text: `Updated role for ${this.email || this.name}.`,
          showConfirmButton: false,
          timer: 1800
        })

        setTimeout(() => this.$router.push({ name: 'settings.permissions.users' }), 1000)
      } catch (err) {
        console.error(err)
        await this.$swal.fire({
          icon: 'error',
          iconColor: '#4F83E3',
          title: err.response?.data?.message || 'Error while updating user',
          showConfirmButton: false,
          timer: 3000
        })
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('projects/hasAccessToPage', 'members.update')
    this.roles = await this.getRoles()
    const data = await this.getMember(this.$route.params.member_id)

    if (Object.keys(data).length) {
      this.name = data.name
      this.email = data?.user?.email
      this.role = data?.role?.id
    }
  }
}
</script>
<style scoped>
.form-control.is-valid,
.form-control.is-invalid,
.custom-select.is-valid,
.custom-select.is-invalid {
  background-image: none !important;
  padding-right: 0.75rem !important;
}
</style>